import { render, staticRenderFns } from "./ProspectCampaignTable.vue?vue&type=template&id=78963251&scoped=true&"
import script from "./ProspectCampaignTable.vue?vue&type=script&lang=js&"
export * from "./ProspectCampaignTable.vue?vue&type=script&lang=js&"
import style0 from "./ProspectCampaignTable.vue?vue&type=style&index=0&id=78963251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78963251",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VIcon,VList,VMenu,VSelect})
